// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cyHvbkwF9rvkMg2DLbuX {
  font-size: 1rem;
}
.cyHvbkwF9rvkMg2DLbuX em {
  font-size: 1rem;
  font-weight: 500;
  padding: 0 0.4em;
  background-color: var(--background);
}
.cyHvbkwF9rvkMg2DLbuX p {
  padding: 0.5em 0;
}
.cyHvbkwF9rvkMg2DLbuX [name="password"] {
  margin: 0 0.4em;
}
.cyHvbkwF9rvkMg2DLbuX .username {
  visibility: hidden;
  overflow: hidden;
  height: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `cyHvbkwF9rvkMg2DLbuX`,
	"username": `username`
};
export default ___CSS_LOADER_EXPORT___;
